import * as RadixPopover from '@radix-ui/react-popover';
import { useState, type ReactElement, type ReactNode } from 'react';
import { useBreakpoint } from '../../hooks/useMediaQuery';
import { Sheet } from '../Dialog/Dialog';
import s from './Popover.module.css';

export type PopoverProps = {
  trigger: ReactElement;
  /** Title for the phone sheet (and the popover's accessible name). */
  title: string;
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

/** Small contextual panel (e.g. the claim-quantity stepper): a sheet on phones, a popover from md. */
export function Popover({ trigger, title, children, open, onOpenChange }: PopoverProps) {
  const desktop = useBreakpoint('md');
  const [inner, setInner] = useState(false);
  const isOpen = open ?? inner;
  const setOpen = (v: boolean) => {
    setInner(v);
    onOpenChange?.(v);
  };

  if (!desktop) {
    return (
      <Sheet open={isOpen} onOpenChange={setOpen} trigger={trigger} title={title}>
        {children}
      </Sheet>
    );
  }
  return (
    <RadixPopover.Root open={isOpen} onOpenChange={setOpen}>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          className={s.popover}
          sideOffset={8}
          collisionPadding={12}
          aria-label={title}
        >
          {children}
          <RadixPopover.Arrow className={s.arrow} />
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
